const EventEmitter = require('event-emitter-es6');

export default class SearchBox extends EventEmitter {
    constructor(el) {
        super();
        this.el = el;
        this.input = this.el.querySelector('.searchBox__input');

        this.bindEvents();
    }

    getSearchValue() {
        return this.input.value.toLowerCase();
    }

    bindEvents() {
        this.input.addEventListener('input', () => this.searchHandler());
    }

    searchHandler() {
        const value = this.getSearchValue();
        this.emit('search', value);
    }
}



// WEBPACK FOOTER //
// ./src/components/searchBox/searchBox.js